export class TravelAgentBasicInfoModel {
    TravelAgentId: number;
    NameOfCompany: string;
    PointOfContact: string;
    EmailId: string;
    PhoneNo: string;
    AlternatePhoneNo: string;
    Street: string;
    CityId: number;
    StateId: number;
    PINCode: string;
    CountryId: number;
    RegistrationNo: string;
    GSTNo: string;
    IsActive: boolean;
    UserId: number;

    constructor() {
        this.TravelAgentId = 0
        this.NameOfCompany = ""
        this.PointOfContact = ""
        this.EmailId = ""
        this.PhoneNo = ""
        this.AlternatePhoneNo = ""
        this.Street = ""
        this.CityId = 0
        this.StateId = 0
        this.PINCode = ""
        this.CountryId = 0
        this.RegistrationNo = ""
        this.GSTNo = ""
        this.IsActive = true
        this.UserId = 0
    }
}

export class TravelAgentOperationsInfoModel {
    TravelAgentId: number;
    AgencyTypeIds: number[];
    TravelSegmentIds: number[];
    CommunicationChannelIds: number[];
    OperationalHour: string | null;
    UserId: number;


    constructor() {
        this.TravelAgentId = 0
        this.AgencyTypeIds = []
        this.TravelSegmentIds = []
        this.CommunicationChannelIds = []
        this.OperationalHour = null
        this.UserId = 0
    }
}

export class TravelAgentAssignmentModel {
    TravelAgentId: number;
    SalesManagerUserId: number;
    KAMManagerUserId: number;
    RegionId: number;
    UserId: number;


    constructor() {
        this.TravelAgentId = 0
        this.SalesManagerUserId = 0
        this.KAMManagerUserId = 0
        this.RegionId = 0
        this.UserId = 0
    }
}

export class TravelAgentFinanceModel {
    TravelAgentId: number;
    BankMasterId: number;
    AccountNo: string;
    IFSCCode: string;
    BranchName: string;
    CreditLimit: number;
    TravelAgentPaymentTermsMasterId: number;
    UserId: number;


    constructor() {
        this.TravelAgentId = 0
        this.BankMasterId = 0
        this.AccountNo = ""
        this.IFSCCode = ""
        this.BranchName = ""
        this.CreditLimit = 0
        this.TravelAgentPaymentTermsMasterId = 0
        this.UserId = 0
    }
}

export class TravelAgentAddonInfoModel {
    TravelAgentId: number;
    LeadSourceMasterId: number;
    LeadSourceOtherRemark: string;
    Remarks: string;
    UserId: number;
    AgencyRegistrationDocName: string;
    AgencyRegistrationDocPath: string;
    PANDocName: string;
    PANDocPath: string;
    SpecialAgreementDocName: string;
    SpecialAgreementDocPath: string;

    constructor() {
        this.TravelAgentId = 0
        this.LeadSourceMasterId = 0
        this.LeadSourceOtherRemark = ""
        this.Remarks = ""
        this.AgencyRegistrationDocName = ""
        this.AgencyRegistrationDocPath = ""
        this.PANDocName = ""
        this.PANDocPath = ""
        this.SpecialAgreementDocName = ""
        this.SpecialAgreementDocPath = ""
        this.UserId = 0
    }
}